import moment, {Moment} from "moment";
import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class AcpSettingsService {
    async getAcpSettingsForCustomer(clientId: number, environmentName?: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/AcpSettings/${clientId}`;
        if (environmentName) url += `?environmentName=${encodeURIComponent(environmentName)}`;
        let response = await getAuthenticatedFetch()(url);
        return await response.json();
    }

    async updateAcp24HFileForCustomer(clientId: number, settingId: number, dateTime: Moment, environmentName?: string) {
        const dateTimeNow = moment();
        dateTime.utc(true);
        dateTimeNow.utc(true);

        if (dateTime.isAfter(dateTimeNow)) {
            dateTime.subtract(1, 'day');
        }
        
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/AcpSettings/${clientId}/settings/${settingId}/update24HFile?dateTime=${dateTime.toJSON()}`;
        if (environmentName) url += `&environmentName=${encodeURIComponent(environmentName)}`;
        let response = await getAuthenticatedFetch()(url, {
            method: 'PATCH'
        });
        
        if (!response.ok) {
            throw new Error();
        }
        
        return response;
    }

    async runEmployeeFiltersForCCH(clientId: number, environmentName?: string) {
        const url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/AcpSettings/${clientId}/runemployeefiltersforcch${environmentName ? `?environmentName=${encodeURIComponent(environmentName)}` : ''}`;
        const response = await getAuthenticatedFetch()(url, {
            method: 'POST'
        });
        if (!response.ok) {
            throw new Error();
        }
        return response;
    }

    async runServiceLocationFiltersForCCH(clientId: number, environmentName?: string) {
        const url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/AcpSettings/${clientId}/runservicelocationfiltersforcch${environmentName ? `?environmentName=${encodeURIComponent(environmentName)}` : ''}`;
        const response = await getAuthenticatedFetch()(url, {
            method: 'POST'
        });
        if (!response.ok) {
            throw new Error();
        }
        return response;
    }
}

export default new AcpSettingsService();
